import { AxiosError } from 'axios'
import { toast } from 'sonner'

export default function showErrorToast(error: Error | string) {
	// If it's an Error object, check if it's an Axios error first
	if (typeof error !== 'string') {
		const axiosError = error as AxiosError<{ message: string; code: string }>

		// If it's an Axios error, prioritize API response message
		if (axiosError.isAxiosError && axiosError.response?.data?.message) {
			return toast.error(axiosError.response.data.message, {
				description: axiosError.response.data.code
					? `CODE: ${axiosError.response.data.code}`
					: undefined,
			})
		}

		// If it's a regular Error object or Axios error without API message
		return toast.error(error.message)
	}

	// Handle string messages directly (fallback)
	return toast.error(error)
}
